import { Component, OnInit, Input } from '@angular/core';
import { OrganizationService } from '../../shared/services/organization.service';
import { CompanyHierarchyComponent } from '../company-hierarchy/company-hierarchy.component';

declare var $: any;

@Component({
  selector: 'app-management-hierarchy',
  templateUrl: './management-hierarchy.component.html',
  styleUrls: ['./management-hierarchy.component.css']
})
export class ManagementHierarchyComponent implements OnInit {
  @Input() associateIdArrays;
  @Input() currentCompanyName;
  oc :any;

  data = {
  };
  public levelSelected ;
  public graphicalOrTabuler = 'tabular';
  public autoCompleteOrganization :any;
  public isNoAssociates: Boolean = true;
  public levels = [];
  constructor(public organizationService: OrganizationService) { }

   colorCoding(payLoad) {
     
    if (payLoad['children']) {
      let colorClassApplied = "";
          if (payLoad.assoc.company === this.currentCompanyName) {
            colorClassApplied = 'org-chart-same-company-color';
          } else {
            colorClassApplied = 'org-chart-diff-company-color';
          }
          payLoad['className'] = colorClassApplied;
        payLoad['children'].forEach(child => {
          // console.log('forEach',child.assoc.name )
          let colorClassApplied = "";
          if (child.assoc.company === this.currentCompanyName) {
            colorClassApplied = 'org-chart-same-company-color';
          } else {
            colorClassApplied = 'org-chart-diff-company-color';
          }
          child['className'] = colorClassApplied;
          this.colorCoding(child);
        });
    } else {
      // console.log('else',payLoad.assoc.name )
      let colorClassApplied = "";
      if (payLoad.assoc.company === this.currentCompanyName) {
        colorClassApplied = 'org-chart-same-company-color';
      } else {
        colorClassApplied = 'org-chart-diff-company-color';
      }
      payLoad['className'] = colorClassApplied;
        return;
    }
}

  ngOnInit() {
    this.organizationService.getOrganization().subscribe((orgs) => {
      this.autoCompleteOrganization = orgs;
      const subsidiaryIds = this.organizationService.getSubsidiariesOrganization(this.associateIdArrays, this.autoCompleteOrganization);
      // this.associateIdArrays.concat(subsidiaryIds);
      subsidiaryIds.push(this.associateIdArrays[0]);
      this.organizationService.getIndivudalCompanyHeirarchy(subsidiaryIds).subscribe(data =>
        {
          if (Object.keys(data).length ) {
            this.levels = data['levels'];
            this.data  = data['Opcos'];
            // add classNames for color coding
            this.colorCoding(this.data);
            this.isNoAssociates = false;
            $('#orga_chart_main').on('mouseenter mouseleave',function() {
              $('.popover').removeClass('show');
            });
            $('.popover').on('mouseleave',function() {
              $('.popover').removeClass('show');
            });
            $('#chartContainerId').on('mouseleave', '.isNode', function(event) {
              var node= $(this);
              $('.popover').removeClass('show');
            });
            $('#chartContainerId').on('mouseenter', '.isNode', function(event)  {
              event.stopPropagation();
              var node= $(this);
              let asscAvatar = node.attr('assc-avatar'),
                asscName = node.attr('assc-name'),
                asscgroupId = node.attr('assc-groupId'),
                asscJobTitle = node.attr('assc-jobTitle'),
                asscCompany = node.attr('assc-company'),
                asscGender = node.attr('assc-gender'),
                asscId = node.attr('assc-id');
                if (asscName !== 'These Associates belongs to Parent Company') {
                  node.popover({
                    trigger: 'manual',
                    container: 'body',
                    template: `<div class="popover" role="tooltip">
                        <div class="arrow"></div>
                        <div class="org-popover">
                          <div class="row container-fluid">
                            <div class="col-sm-4">
                              <img src='https://s3-ap-southeast-1.amazonaws.com/epeoples3-production/`+ asscAvatar +`' class="xs-mt-15" width="42"/>
                            </div>
                            <div class="col-sm-8">
                              <h4> <a href='home/associate/profile/view/${asscId}'>` +asscName+`</a></h4>
                              <p>`+asscgroupId+`</p>
                            </div>
                          </div>
                          <div class="row container-fluid">
                            <div class="col-sm-4">
                              <p><b>Job Title</b></p>
                            </div>
                            <div class="col-sm-8">
                              <p>`+asscJobTitle+`</p>
                            </div>
                          </div>
                          <div class="row container-fluid">
                            <div class="col-sm-4">
                              <p><b>Company</b></p>
                            </div>
                            <div class="col-sm-8">
                              <p>`+asscCompany+`</p>
                            </div>
                          </div>
                          <div class="row container-fluid">
                            <div class="col-sm-4">
                              <p><b>Gender</b></p>
                            </div>
                            <div class="col-sm-8">
                              <p>`+asscGender+`</p>
                            </div>
                          </div>
                        </div>
                      </div>`
                  })
                  node.popover('show');
                }
            });
            this.oc = $('#chartContainerId').orgchart({
              data: this.data,
              nodeTitle: 'title',
              nodeContent: 'description',
              draggable: false,
              // pan: false,
              zoom: true,
              zoomoutLimit: 0.3,
              zoominLimit: 2,
              visibleLevel: 3,
              nodeId: data['id'],
              exportButton: false,
              toggleSiblingsResp: false,
              nodeTemplate: function(data) {
                return `<div class="borderBox isNode " assc-id="`+data.assoc.id+`" assc-name="`+data.assoc.name+`" assc-avatar="`+data.assoc.avatarUrl+`"
                assc-jobTitle="`+data.assoc.jobDescription+`" assc-company="`+data.assoc.company+`"
                assc-gender="`+data.assoc.gender+`" assc-groupId="`+data.assoc.groupId+`" level=${data.level}
                data-toggle="popover" data-content="Org popover" data-animation="false">
                          <div class="row">
                            <div class="col-lg-4">
                              <div class="imgDimCompanyTile">
                                <img src='https://s3-ap-southeast-1.amazonaws.com/epeoples3-production/`+data.assoc.avatarUrl+`' class="img-responsive maxHeightImg"/>
                              </div>
                            </div>

                            <div class="col-lg-8 text-left xs-pl-5">
                              <div class="toLeft nameCompanyTile">
                                <div class="d_gray mb-4" style="text-align: center; text-align-last: center; font-size: 9px;">
                                <a href='home/associate/profile/view/${data.assoc.id}'>`+data.assoc.name+`
                                </a>
                                </div>
                              </div>

                              <div class="toLeft">
                                <div class="l_gray">`+data.assoc.groupId+`</div>
                              </div>
                            </div>

                          </div>
                        </div>`;
              },
              initCompleted :() => {
                let tx= $(".orgchart").outerWidth() / 2 * -1,
                offset = $(".chartContainerId").outerWidth(),
                totalOffset = tx + offset ;
                $(".orgchart").css( {"transform": `matrix(0.8, 0, 0, 0.8, `+ totalOffset+`, -13)`});
                // @TODO this method handles click on any individual node
                // need to only display parent and child level of clicked node
                // $('.isNode').on('click',(event) => {
                //   console.log('Click called isNode', event['currentTarget']['attributes']['level']['nodeValue']);
                //   let nodeLevel = event['currentTarget']['attributes']['level']['nodeValue'];
                //   function showRelevantLevels(payLoad,level) {
                //     if (payLoad['children']) {
                //         payLoad['children'].forEach(child => {
                //           showRelevantLevels(child,level);
                //         });
                //     } else {
                //         // console.log('Payload', payLoad);
                //         // console.log('payloadLevel and level',payLoad['level'], level,+payLoad['level'] > +level + 1 , +payLoad['level'] < +level - 1 );
                //         if (+payLoad['level'] > +level + 1 || +payLoad['level'] < +level - 1 ) {
                //           payLoad['collapsed'] = true;
                //         } else {
                //           payLoad['collapsed'] = false;
                //         }
                //         return;
                //     }
                //   }
                //   console.time('showRelevantLevles');
                //   showRelevantLevels(this.data,nodeLevel);
                //   console.timeEnd('showRelevantLevles');
                //   console.time('orgChartInit');
                //   this.oc.init({
                //     'visibleLevels': 12,
                //     'pan': false,
                //     'zoom': true,
                //     'zoomoutLimit': 0.4,
                //     toggleSiblingsResp: false
                //   });
                //   console.timeEnd('orgChartInit');
                // });
              }

            }); // #chartContainerId finished here
          } else {
            this.isNoAssociates = true;
          }
        }, e => {
          console.log(e);
        });
  }, (error) => { });


  }

  getOrganizations() {
  }

  levelChange(event){
    let tx= $("#rootNode").position() / 2 * -1,
    offset = $(".chartContainerId").outerWidth(),
    totalOffset = tx + offset ;
    $(".orgchart").css( {"transform": `matrix(0.8, 0, 0, 0.8, `+ totalOffset+`, -13)`});
    this.oc.init({
      'visibleLevel': Number(event),
      'pan': false,
      'zoom': true,
      'zoomoutLimit': 0.4,
      toggleSiblingsResp: false
    });
  }

  
}
